export type AcceptTermsType = {
  url: string;
  ariaLabel: string;
  linkText: string;
  textBefore: string;
};

export type GeneralSetting = {
  apiUrl: string;
  socketUrl: string;
  amplitudeApiKey: string;
  enableDebuggingFeatures: boolean;
  recaptchaPublicKey: string;
  chatBoxMaxLength: number;
  acceptTerms?: AcceptTermsType;
  gitTag: string;
  env: string;
  country: string;
  dataDogSettings: {
    clientToken: string;
    applicationId: string;
  } | null;
};

export const generalSettings: GeneralSetting = {
  // Trim trailing / from URLs if present, since the code adds it when needed.
  apiUrl: process.env.REACT_APP_API_URL
    ? (process.env.REACT_APP_API_URL as string).replace(/[/]$/, "")
    : "",
  socketUrl: process.env.REACT_APP_SOCKET_URL
    ? (process.env.REACT_APP_SOCKET_URL as string).replace(/[/]$/, "")
    : "",
  env: process.env.REACT_APP_ENV ? (process.env.REACT_APP_ENV as string) : "",
  dataDogSettings:
    process.env.REACT_APP_DD_RUM_CLIENT_TOKEN &&
    process.env.REACT_APP_DD_RUM_APPLICATION
      ? {
          clientToken: process.env.REACT_APP_DD_RUM_CLIENT_TOKEN as string,
          applicationId: process.env.REACT_APP_DD_RUM_APPLICATION as string,
        }
      : null,
  gitTag: process.env.REACT_APP_GIT_TAG
    ? process.env.REACT_APP_GIT_TAG
    : "no-git-tag",
  country: process.env.REACT_APP_COUNTRY
    ? (process.env.REACT_APP_COUNTRY as string)
    : "",
  amplitudeApiKey: process.env.REACT_APP_AMPLITUDE_API_KEY as string,
  enableDebuggingFeatures: Boolean(
    process.env.REACT_APP_ENABLE_DEBUGGING_FEATURES === "true"
  ),
  recaptchaPublicKey: process.env.REACT_APP_RECAPTCHA_PUBLIC_KEY as string,
  chatBoxMaxLength: 300,
};
